module.exports = __webpack_public_path__ + "static/img/brees-2005-slide-2.bfe7e78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-slide-2.jpg
// module id = dyuO
// module chunks = 1